import React, { useMemo } from 'react';
import { Checkbox, CheckboxGroup, Col, NewDateInput, Heading, Row, SelectAllCheckbox, SelectInput, themes, } from '@digitools/honest-react';
import { useFormApi, useFormState } from 'informed';
import { resetDateFields, validateDatesSearchOn, validateStatusAndDatesGroup, } from './FilterMyReportValidation';
import * as _ from 'lodash';
import styled from 'styled-components';
import { isBefore, isFuture, parse } from 'date-fns';
import useTranslate from 'src/hooks/useTranslate';
import LanguageToggle from 'src/utils/LanguageToggle';
const StyledLabel = styled('label') `
  margin: 0;
  display: inline-block;
  font-weight: bold;
  font-size: 1rem;

  & + div {
    margin-top: 10px;
  }
`;
const SelectStatusAndDates = ({ filterStatusCodes, reportFilterCategory }) => {
    const filterReportsByDate = dateSearchOnDropDownValue(reportFilterCategory);
    const statusArray = _.chunk(filterStatusCodes, 3);
    const { t } = useTranslate();
    // ---------------------------------------------------- //
    // TODO: Fix this atrocity.
    const formState = useFormState();
    const formApi = useFormApi();
    const validateDateSelectedAndNotInFuture = (props) => {
        if (props === '' || !props) {
            return <LanguageToggle en='From date: invalid date' es='Fecha desde: fecha no válida'/>;
        }
        else if (isFuture(parse(props, 'P', new Date()))) {
            return <LanguageToggle en='From date: date cannot be in the future' es='Fecha desde: la fecha no puede ser en el futuro'/>;
        }
    };
    const validateDateSelectedAndAfterFromDate = (props) => {
        if (props === '' || !props) {
            return <LanguageToggle en='Through date: invalid date' es='Fecha hasta: fecha no válida'/>;
        }
        else if (isBefore(new Date(props), new Date(formApi.getValue("fromDate")))) {
            return <LanguageToggle en='Through date: date cannot be less than from date' es='Fecha hasta: la fecha no puede ser anterior a la fecha desde'/>;
        }
    };
    const statusGroupValidator = useMemo(() => {
        return validateStatusAndDatesGroup(formApi);
    }, [formState.values['dateSearchBy'], formState.values['dateSearchBy']]);
    const dateSearchByValidator = useMemo(() => {
        return validateDatesSearchOn(formApi);
    }, [formState.touched['dateSearchBy']]);
    const shouldValidateDateSearchByOnChange = useMemo(() => {
        return formApi.getTouched('dateSearchBy');
    }, [formState.touched['dateSearchBy']]);
    // ---------------------------------------------------- //
    const statusCheckboxRow = statusArray.map((subStatusCodes, indexRow) => (<Col lg={4} key={indexRow}>
      {subStatusCodes.map((status, index) => {
            if (reportFilterCategory === 'Accommodation Services' && status.code === 'DENIED') {
                return (<Col key={'col' + index} style={{ marginTop: '.5rem' }} hidden={true}>
              <Checkbox field={status.code} checked={false} label={status.label}/>
            </Col>);
            }
            else {
                return (<Col key={'col' + index} style={{ marginTop: '.5rem' }}>
              <Checkbox field={status.code} checked={status.checked} label={status.label}/>
            </Col>);
            }
        })}
    </Col>));
    const STATUS_AND_OR_DATES = 'Status and/or dates';
    return (<div style={{ marginTop: '2rem' }}>
      <div style={{ borderLeft: `3px solid ${themes.rebrand.palette.primary}`, paddingLeft: '1rem' }}>
        <Heading elemType={'h2'} elemStyle={'h3'} color={'grayDarker'}>
          {STATUS_AND_OR_DATES}
        </Heading>
        <CheckboxGroup key={'statusgroup'} field={'statusgroup'} label='Status' theme={themes.rebrand} validate={statusGroupValidator} validateOnChange={true} notify={['dateSearchBy']}>
          <Row>
            <Col lg={4} style={{ paddingLeft: '14px' }}>
              <SelectAllCheckbox field={'ASC'} title={STATUS_AND_OR_DATES}/>
            </Col>
          </Row>
          <Row style={{ marginTop: '-0.05rem' }}>{statusCheckboxRow}</Row>
        </CheckboxGroup>
        <hr />
        <div>
          <Row>
            <Col lg={4} md={4}>
              <Row>
                <Col>
                  <StyledLabel id='searchOnText'>Search on</StyledLabel>
                </Col>
              </Row>
              <Row>
                <Col>
                  <SelectInput label={t({
            english: 'Choose an option',
            spanish: 'Elige una opción',
        })} field='dateSearchBy' validate={dateSearchByValidator} validateOnChange={shouldValidateDateSearchByOnChange} notify={['statusgroup']} theme={themes.rebrand} options={filterReportsByDate} hidePlaceholder={true} errorMessage={'Please select Status and/or Date'} onChange={resetDateFields(formApi)}/>
                </Col>
              </Row>
            </Col>
            <Col lg={4} md={4}>
              <Row>
                <Col>
                  <StyledLabel id='fromText'>From</StyledLabel>
                </Col>
              </Row>
              <Row>
                <Col>
                  <NewDateInput label={'(mm/dd/yyyy)'} field={'fromDate'} data-testid={'fromDate'} disabled={formApi.getValue('dateSearchBy') ? false : true} theme={themes.rebrand} minDate={undefined} maxDate={new Date()} validate={(props) => validateDateSelectedAndNotInFuture(props)}/>
                </Col>
              </Row>
            </Col>
            <Col lg={4} md={4}>
              <Row>
                <Col>
                  <StyledLabel id='fromText'>Through</StyledLabel>
                </Col>
              </Row>
              <Row>
                <Col>
                  <NewDateInput label={'(mm/dd/yyyy)'} field={'toDate'} theme={themes.rebrand} disabled={formApi.getValue('dateSearchBy') ? false : true} minDate={new Date(formApi.getValue("fromDate"))} maxDate={undefined} validate={(props) => validateDateSelectedAndAfterFromDate(props)}/>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </div>
      <hr />
    </div>);
};
export default SelectStatusAndDates;
const dateSearchOnDropDownValue = (reportFilterCategory) => {
    const claimFilterReportsByDate = [
        { label: 'Choose an option', value: '' },
        { label: 'claim received date', value: 'Claim Received Date' },
        { label: 'closed date', value: 'Closed Date' },
        { label: 'disability date', value: 'Disability Date' },
        { label: 'determination date', value: 'Determination Date' },
    ];
    const leaveFilterReportsByDate = [
        { label: 'Choose an option', value: '' },
        { label: 'leave received date', value: 'Leave Received Date' },
        { label: 'closed date', value: 'Closed Date' },
        { label: 'determination date', value: 'Determination Date' },
        { label: 'leave begin date', value: 'Leave Begin Date' },
    ];
    const asFilterReportsByDate = [
        { label: 'Choose an option', value: '' },
        { label: 'accommodation received date', value: 'Accommodation Received Date' },
        { label: 'accommodation closed date', value: 'Accommodation Closed Date' },
        { label: 'provided start date', value: 'Provided Start Date' },
    ];
    switch (reportFilterCategory) {
        case 'Claim': {
            return claimFilterReportsByDate;
        }
        case 'Leave': {
            return leaveFilterReportsByDate;
        }
        case 'Accommodation Services': {
            return asFilterReportsByDate;
        }
        default:
            return [{ label: 'Choose an option', value: '' }];
    }
};
